export { StaticDatePicker } from "./StaticDatePicker.js";